import { PLANS_FETCH, PLANS_ADD, PLANS_EDIT, PLANS_REMOVE, PLANS_ERROR } from "../store/types";

const INITIAL_STATE = {
    date: [],
    loading: false,
    error: {
        flag: false,
        msg: null
    }
};

export const plansreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PLANS_FETCH:
            return {
                ...state,
                date: action.payload,
                loading: false
            };
        case PLANS_ADD:
            return {
                ...state,
                date: [...state.date, action.payload],
                loading: false
            };
        case PLANS_EDIT:
            const updatedData = state.date.map(item =>
                item.ref === action.payload.ref ? action.payload : item
            );
            return {
                ...state,
                date: updatedData,
                loading: false
            };
        case PLANS_REMOVE:
            const filteredData = state.date.filter(item => item.ref !== action.payload.ref);
            return {
                ...state,
                date: filteredData,
                loading: false
            };
        case PLANS_ERROR:
            return {
                ...state,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload
                }
            };
        default:
            return state;
    }
};